module.exports = __webpack_public_path__ + "assets/cf33b70023c5ab4f3e01a138e2cb6ae3.eot";